import Container from "components/Container";

const Dashboard = () => {
  return <Container>Welcome</Container>;
};

export default Dashboard;
